import { render, staticRenderFns } from "./PermissionTable.vue?vue&type=template&id=b083ae2a"
import script from "./PermissionTable.vue?vue&type=script&lang=ts"
export * from "./PermissionTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports